import React from 'react';

import AdminReferralConversationPage from './AdminReferralConversationPage';

const AdminReferralConversationAsReferrerPage: React.FC = () => (
  <AdminReferralConversationPage viewAsRole="referrer" />
);

export default AdminReferralConversationAsReferrerPage;
